export default "__VITE_ASSET__CHR38T6$__"